import { VIEW_CHATTER_CLIENT, VIEW_HOME_EDUCATION, VIEW_PRIVATE_CLIENT, SCHOOL_CLIENT_DETAIL } from "./paths";

export const API_URL = process.env.REACT_APP_API_BASE_URL;

// Toggle duplicate-client checks by client type.
export const DUPLICATE_CLIENT_CHECKS = {
  school: true,
  home_education: true,
  private: true,
  chatter: true,
};

export const SSO_URL = process.env.REACT_APP_SSO_BASE_URL;

export const CHAT_SERVER_URL = process.env.REACT_APP_CHAT_SERVER_URL;

// Socket servers intentionally do not include the REST API's `/api/v1` suffix.
// Keeping these configurable lets each deployed environment point at its matching
// admin and therapist socket servers.
const removeApiVersionPath = (url = "") => url.replace(/\/api\/v1\/?$/, "");

export const ADMIN_SOCKET_URL = process.env.REACT_APP_ADMIN_SOCKET_URL || removeApiVersionPath(API_URL);
export const THERAPIST_SOCKET_URL = process.env.REACT_APP_THERAPIST_SOCKET_URL;

export const PARENT_PANEL_URL = 'https://nausheen-guardian.suffescom.dev'

export const MIME_TYPES = {
  png: "image/png",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  webp: "image/webp",
  pdf: "application/pdf",
  video: "video/mp4",
  images: "image/*",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ppt: "application/vnd.ms-powerpoint",
  pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  pptm: "application/vnd.ms-powerpoint.presentation.macroenabled.12"
}

export const PRIMARY_COLOR = "#315D99";

export const GENDER_OPTIONS = [
  {
    value: "male",
    label: "Male",
  },
  {
    value: "female",
    label: "Female",
  }
];

export const LOCATION_TYPE_OPTIONS = [
  {
    value: "school",
    label: "School",
  },
  {
    value: "community",
    label: "Community",
  }
];

export const DAY_OPTIONS = [
  {
    value: "monday",
    label: "Monday",
  },
  {
    value: "tuesday",
    label: "Tuesday",
  },
  {
    value: "wednesday",
    label: "Wednesday",
  },
  {
    value: "thursday",
    label: "Thursday",
  },
  {
    value: "friday",
    label: "Friday",
  },
  {
    value: "saturday",
    label: "Saturday",
  },
  {
    value: "sunday",
    label: "Sunday",
  }
];

export const SERVICE_STATUS_OPTIONS = [
  {
    value: "NotYetSeen",
    label: "Not Yet Seen",
  },
  {
    value: "Screening",
    label: "Screening",
  },
  {
    value: "Assessment",
    label: "Assessment",
  },
  {
    value: "Individual",
    label: "Individual",
  },
  {
    value: "Classroom",
    label: "Classroom",
  },
  {
    value: "Consultation",
    label: "Consultation",
  },
  {
    value: "Discharge",
    label: "Discharge",
  },
];

export const GRADE_OPTIONS = [
  {
    value: "NA",
    label: "NA",
  }, {
    value: "PS",
    label: "PS",
  },
  {
    value: "JK",
    label: "JK",
  },
  {
    value: "KG",
    label: "KG",
  },
  {
    value: "1",
    label: "1",
  },
  {
    value: "2",
    label: "2",
  },
  {
    value: "3",
    label: "3",
  },
  {
    value: "4",
    label: "4",
  },
  {
    value: "5",
    label: "5",
  },
  {
    value: "6",
    label: "6",
  },
  {
    value: "7",
    label: "7",
  },
  {
    value: "8",
    label: "8",
  },
  {
    value: "9",
    label: "9",
  },
  {
    value: "10",
    label: "10",
  },
  {
    value: "11",
    label: "11",
  },
  {
    value: "12",
    label: "12",
  },
];

export const FUNDING_SOURCE_OPTIONS = [
  {
    value: 1,
    label: "One",
  },
  {
    value: 2,
    label: "Two",
  },
  {
    value: 3,
    label: "Three",
  },
];

export const CONFIRMATION_OPTIONS = [
  {
    value: "yes",
    label: "Yes",
  },
  {
    value: "no",
    label: "No",
  }
];

export const CASE_STATUSES = {
  not_seen_yet: "Not Seen Yet"
}

export const CLIENT_TYPE_OPTIONS = [
  {
    value: "school",
    label: "School",
  },
  {
    value: "home_education",
    label: "Home Education",
  },
  {
    value: "chatter",
    label: "Chatter",
  },
  {
    value: "private",
    label: "Private",
  },
  {
    value: "mdt",
    label: "MDT",
  }
];
export const SUPPORT_STAFF_CLIENT_TYPE_OPTIONS = [
  {
    value: "school",
    label: "School",
  },
  {
    value: "private",
    label: "Private",
  }
];

export const CLIENT_TYPE = {

  school: "School",
  home_education: "Home Education",
  chatter: "Chatter",
  private: "Private"
};

export const STATUS_OPTIONS = [
  {
    value: "active",
    label: "Active",
  },
  {
    value: "archived",
    label: "Archived",
  },
  {
    value: "inactive",
    label: "Inactive",
  }
];

export const THERAPIST_STATUS_OPTIONS = [
  {
    value: "",
    label: "All",
  },
  {
    value: "active",
    label: "Active",
  },
  {
    value: "archived",
    label: "Archived",
  },
  {
    value: "inactive",
    label: "Inactive",
  }
];

export const APPOINTMNET_TYPE = [
  {
    value: "free",
    label: "Free",
  },
  {
    value: "aid",
    label: "Paid",
  },
];

export const CONSENT_STATUS_OPTIONS = [
  {
    value: "active",
    label: "Active",
  },
  {
    value: "archived",
    label: "Archived",
  },
  {
    value: "draft",
    label: "Draft",
  }
];

export const EXPORT_STATUS_OPTIONS = [
  {
    value: "",
    label: "All",
  },
  {
    value: "P",
    label: "Pending",
  },
  {
    value: "I",
    label: "Incomplete",
  },
  {
    value: "C",
    label: "Complete",
  },
  {
    value: "E",
    label: "Error",
  }
];

export const EXPORT_STATUS = {
  "P": "Pending",
  "I": "Incomplete",
  "C": "Complete",
  "E": "Error"
};

export const EXPORT_MODULES = {
  "client_school": "Clients/School",
  "client_home_education": "Clients/Home Education",
  "client_chatter": "Clients/Chatter",
  "client_private": "Clients/Private",
  "client_peer": "Clients/Peer",
  "client_mdt": "MDT"
};

export const TEMPLATE_OPTIONS = [
  {
    value: "therapist_account_activation",
    label: "Therapist Account Activation"
  },
  // {
  //   value: "trend_admin_account_activation",
  //   label: "Admin Account Activation"
  // },
  // {
  //   value: "client_assignment_account_activation",
  //   label: "Assignment Aaccount Activation"
  // },
  // {
  //   value: "forgot_password_email",
  //   label: "Forgot Password"
  // },
  // {
  //   value: "session_reviewed_email",
  //   label: "Session Reviewed"
  // },
  // {
  //   value: "graph_exported_email",
  //   label: "Graph Exported"
  // },
  {
    value: "therapist_mdt_assessment_date_request",
    label: "Therapist MDT Assessment Date Request"
  },
  {
    value: "program_add",
    label: "Add Program"
  },
  {
    value: "lesson_add",
    label: "Resource"
  },
  {
    value: "reset_password",
    label: "Reset Password"
  },
  {
    value: "assessment_terms_completed",
    label: "Assessment Terms Completed"
  },
  {
    value: "send_report",
    label: "Report Completed"
  },
  {
    value: "assessment_reminder",
    label: "Assessment Reminder"
  },
  {
    value: "chatter_peer_evaluation",
    label: "Chatter Peer Evaluation"
  },
  {
    value: "chatter_reference_letter",
    label: "Chatter Reference Letter"
  }
];

export const TEMPLATES = {

  therapist_account_activation: "Therapist Account Activation",
  trend_admin_account_activation: "Admin Account Activation",
  client_assignment_account_activation: "Assignment Aaccount Activation",
  forgot_password_email: "Forgot Password",
  session_reviewed_email: "Session Reviewed",
  graph_exported_email: "Graph Exported",
  therapist_mdt_assessment_date_request: "Therapist MDT Assessment Date Request",
  program_add: "Add Program",
  lesson_add: "Add Lesson",
  reset_password: "Reset Password",
  assessment_terms_completed: "Assessment Terms Completed",
  send_report: "Assessment Report",
  assessment_reminder: "Assessment Reminder",
  chatter_peer_evaluation: "Chatter Peer Evaluation",
  chatter_reference_letter: "Chatter Reference Letter"
}

export const TEMPLATES_TITLE = {

  therapist_account_activation: "Therapist",
  trend_admin_account_activation: "Admin",
  client_assignment_account_activation: "Client",
  forgot_password_email: "Admin",
  session_reviewed_email: "Client",
  graph_exported_email: "Client",
  therapist_mdt_assessment_date_request: "Therapist",
  program_add: "Client",
  lesson_add: "Client",
  reset_password: "Client",
  assessment_terms_completed: "Therapist",
  send_report: "Therapist",
  assessment_reminder: "Therapist",
  chatter_peer_evaluation: "Client",
  chatter_reference_letter: "Client",
  email_otp: "Therapist",
  therapist_lesson_shared: "Client",
  home_education_intake_form: "Client",
  peer_reference_letter: "Client"
}

export const CLIENT_NOTE_TYPES = {

  school: "clients-school",
  home_education: "clients-home-education",
  private: "clients-private",
  chatter: "clients-chatter"
}

export const CLIENT_PATH = {
  "school": SCHOOL_CLIENT_DETAIL,
  "home_education": VIEW_HOME_EDUCATION,
  "chatter": VIEW_CHATTER_CLIENT,
  "private": VIEW_PRIVATE_CLIENT
}
export const INTAKE_TEAM_EMAIL = "homeed@khancommunicationservices.com";
export const REFERENCE_LETTER_EMAIL = "volunteer@khancommunicationservices.com";

export const PERMISION_TITLE = {
  "client_school": "School Clients",
  "client_home": "Home Clients",
  "client_private": "Private Clients",
  "client_chatter": "Chatter Clients",
  "client_status": "Client Status",
  "therapist_profile": "Therapist Profile",
  "school_profile": "School Profile",
  "school_division": "School Division",
  "chatter_program": "Chatter Program",
  "chatter_lesson_plan": "Chatter Lesson Plan",
  "chatter_peer": "Chatter Peers",
  "discipline_profile": "Discipline Profile",
  "goals": "Goals",
  "funding_source": "Funding Source",
  "mdt_assessment": "MDT Assessment",
  "mdt_status": "MDT Status",
  "mdt_term": "MDT Term",
  "cms": "Content Management System",
  "parent_profile": "Parent Profile",
  "teacher_profile": "Teacher Profile",
  "support_staff_profile": "Support Staff Profile",
  "email_notification": "Email Notifications",
  "firebase_notification": "Firebase Notifications",
  "designation": "Designation",
  "service_status": "Service Status",
  "user_roles_permission": "User Roles and Permissions",
  "report_template_assessment": "Assessment Templates",
  "report_template_chatter": "Chatter Program Descriptions",
  "consent_form": "Consent Forms",
  "manage_exports": "Manage Exports",
  "policy_and_procedures": "Policy & Procedures",
  "client_discharges": "Client Discharges",
  "admin_users": "Admin Users",
};

export const THERAPIST_TYPE_OPTIONS = [
  {
    label: "Veteran",
    value: "veteran"
  },
  {
    label: "Apprentice",
    value: "apprentice"
  }
]
'active', 'inactive', 'suspend', 'blocked', 'archived'

export const SUB_ADMIN_STATUS_OPTIONS = [
  {
    label: "All",
    value: ""
  },
  {
    label: "Active",
    value: "active"
  },
  {
    label: "Inactive",
    value: "inactive"
  },
  {
    label: "Suspend",
    value: "suspend"
  },
  {
    label: "Blocked",
    value: "blocked"
  },
  {
    label: "Archived",
    value: "archived"
  }
]

export const SUB_ADMIN_LOGIN_STATUS_OPTIONS = [
  {
    label: "Active",
    value: "active"
  },
  {
    label: "Archived",
    value: "archived"
  }
]

export const SPECIALIZATION_OPTIONS = {
  "psychologist": "Psychologist",
  "pediatrician": "Physician",
}

export const SPECIALIZATION_OPTIONS_V2 = [
  { label: "Psychologist", value: "psychologist" },
  { label: "Physician", value: "pediatrician" },
]

export const reportDateFormat = "MMM DD, YYYY";


export const CLIENT_TYPE_KEYS = Object.fromEntries(Object.keys(CLIENT_TYPE).map(key => [key, key]));

export const RTK_CACHE_EXPIRATION = 60 * 10; // in seconds

export const APPOINTMENT_SERVICE_OPTIONS = [
  { label: "Counselling", value: "Counselling" },
  { label: "Assessment", value: "Assessment" },
  { label: "Intervention", value: "Intervention" },
  { label: "Consultation", value: "Consultation" },
  { label: "Multi team assessment", value: "Multi team assessment" },
  { label: "Autism assessment", value: "Autism assessment" },
  { label: "Psychology assessment", value: "Psychology assessment" },
  { label: "Learning assessment", value: "Learning assessment" },
  { label: "Chatter programs", value: "Chatter programs" },
  { label: "Other Group programs", value: "Other Group programs" }
];

export const APPOINTMENT_SESSION_TYPE_OPTIONS = [
  { label: "Paid", value: "paid" },
  { label: "Funded", value: "funded" },
];

export const APPOINTMENT_PAYMENT_OPTIONS = [
  { label: "Success", value: "success" },
  { label: "Pending", value: "pending" },
];

export const TIMEZONE_OPTIONS = [
  { label: "MST", value: "MST" },
  { label: "CST", value: "CST" },
  { label: "EST", value: "EST" },
]

export const GOAL_TRACK_PARAMETERS = {
  "I": "Correct",
  "SC": "Self-correct",
  "P": "Prompt",
  "M": "Model",
  "O": "Incorrect",
};

export const GOAL_TRACK_PARAMETERS_STAFF = {
  "I": "Correct",
  "P": "Prompt",
  "O": "Incorrect",
}

export const staffStatusOptions = [
  {
    label: "All",
    value: ""
  },
  {
    label: "Active",
    value: "active"
  },
  {
    label: "Archived",
    value: "archived"
  },
  {
    label: "Blocked",
    value: "blocked"
  }
];


export const GOAL_TRACK_PARAMETERS_COLORS = {
  "I": "#51A5A1",
  "SC": "#D2DA26",
  "P": "#b46c9f",
  "M": "#ffc7ef",
  "O": "#C03017",
};

export const APPOINTMENT_CLIENT_TYPE_OPTIONS = [
  {
    value: "home_education",
    label: "Home Education",
  },
  {
    value: "chatter",
    label: "Chatter",
  },
  {
    value: "private",
    label: "Private",
  }
];

export const FUTUTRE_DATE_ERROR_MESSAGE = "Cannot access future target plan."

export const NO_HISTORY_FOUND = 'No History Found'

export const CONSENT_FORM_STATUS_OPTIONS = [
  { label: "Not Verified", value: "unverified", },
  { label: "Verified", value: "verified", },
  { label: "Reassigned", value: "reassigned" }
]

export const ROLES = {
  admin: 1,
  subadmin: 2,
}


export const classroomReportStatusOptions = [
  { label: "In-progress", value: "in-progress" },
  { label: "Copied", value: "copied" },
  { label: "Published", value: "complete" },
];

export const REPORTS_FILTER_OPTIONS = [
  {
    label: "All",
    value: "all"
  },
  {
    label: "Published",
    value: "complete"
  },
  {
    label: "In-Progress",
    value: "processing"
  },
  {
    label: "Copied",
    value: "copied"
  },
  {
    label: "Archived",
    value: "archived"
  },
  {
    label: "Trashed",
    value: "trash"
  },
]


export const DOCUMENT_TYPE_OPTIONS = [
  { label: "Consent", value: "consent" },
  { label: "Document", value: "document" },
  { label: "Report", value: "report" },
]

export const DOCUMENTS_FILTER_OPTIONS = [
  {
    label: "All",
    value: ""
  },
  {
    label: "Document",
    value: "document"
  },
  {
    label: "Report",
    value: "report"
  },
  {
    label: "Consent",
    value: "consent"
  },
]

export const ATTENDANCE_OPTIONS = [
  { label: "Present", value: "present" },
  { label: "Absent", value: "absent" },
]

export const CLIENT_STATUS_OPTION = [
  {
    label: "All",
    value: ""
  },
  {
    label: "Active",
    value: "active"
  },
  {
    label: "Inactive",
    value: "inactive"
  },
  {
    label: "Archived",
    value: "archived"
  },
  {
    label: "Discharged",
    value: "discharged"
  }
]

// Statuses the bulk status action can set. Deliberately narrower than the filter lists above:
// "All" is not a status, and the bulk endpoint does not accept "incoming".
export const BULK_CLIENT_STATUS_OPTIONS = [
  {
    label: "Active",
    value: "active"
  },
  {
    label: "Inactive",
    value: "inactive"
  },
  {
    label: "Archived",
    value: "archived"
  },
  {
    label: "Discharged",
    value: "discharged"
  }
]

export const HOME_CLIENT_STATUS_OPTION = [
  {
    label: "All",
    value: ""
  },
  {
    label: "Active",
    value: "active"
  },
  {
    label: "Incoming",
    value: "incoming"
  },
  {
    label: "Inactive",
    value: "inactive"
  },
  {
    label: "Archived",
    value: "archived"
  },
  {
    label: "Discharged",
    value: "discharged"
  }
]

export const CHATTER_CLIENT_STATUS_OPTION = [
  {
    label: "All",
    value: ""
  },
  {
    label: "Active",
    value: "active"
  },
  {
    label: "Incoming",
    value: "incoming"
  },
  {
    label: "Inactive",
    value: "inactive"
  },
  {
    label: "Archived",
    value: "archived"
  },
  {
    label: "Discharged",
    value: "discharged"
  }
]

// STAFF TYPE OPTIONS
export const STAFF_CLIENT_TYPE_OPTIONS = [
  {
    label: "School",
    value: "school"
  },
  {
    label: "Home Education",
    value: "home_education"
  },
] 

export const STAFF_TYPE_OPTIONS = [
  { label: "School", value: "school" },
  { label: "Home Education", value: "home_education"}
]

export const CLASSROOM_STATUS_OPTIONS = [
  {label: "Complete", value: "complete"},
  {label: "Archived", value: "archived"},
]

export const NOTIFICATION_PRIORITY_OPTIONS = [
  {label: "Simple", value: "simple"},
  {label: "Moderate", value: "moderate"},
  {label: "Advanced", value: "advanced"},
]
